import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { ThemeService } from '../../../shared/theme-service/theme.service';
import { EventTypes } from '../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { CustomerServiceService } from '../customer-service.service';
import { TweenMax, Quint } from 'gsap';
import { SecurityQuestion } from '../models/security-question';
import { Router } from '@angular/router';
import { AutenticationService } from '../../../autentication/autentication.service';
import { Access } from '../../../autentication/models/access';
import { Account } from '../../../autentication/models/account';

@Component({
	selector: 'app-search-client',
	templateUrl: './search-client.component.html',
	styleUrls: ['./search-client.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SearchClientComponent implements OnInit {

	showSecurityQuestions: boolean = false;
	canSendCpf = false;
	formVerifyCpf: FormGroup;
	formSecurityQuestions: FormGroup;
	cpf = '';
	questions: Array<SecurityQuestion> = [];
	loading: boolean;
	questionsError: Array<any> = [];
	accounts: Array<Account> = [];

	constructor(
		private formBuilder: FormBuilder,
		private customerServiceService: CustomerServiceService,
		private router: Router,
		private autenticationService: AutenticationService
	) {

		this.formVerifyCpf = formBuilder.group({
			'cpf': [null, Validators.required]
		});
	}

	ngOnInit() {
		this.customerServiceService.setAccountsClientList(this.accounts);
		AppEventDispatcher.dispatch(EventTypes.CUSTUMER_SERVICE_INFO, {show: false});
	}

	verifyCpf(cpf: string) {
		this.cpf = cpf;
		if (cpf.length > 13) {
			this.canSendCpf = true;
		} else {
			this.canSendCpf = false;
		}
	}

	sendCpf() {
		this.showSecurityQuestions = false;
		this.preload(true);

		if (this.canSendCpf && this.formVerifyCpf.valid) {
			this.autenticationService.getUserByCpf(this.formVerifyCpf.value.cpf).subscribe((access: Access) => {

				if (access.exists) {
					this.customerServiceService.getSecurityQuestions(this.formVerifyCpf.value.cpf).subscribe((questions: Array<SecurityQuestion>) => {
						this.preload(false);

						this.showSecurityQuestions = true;
						this.questions = questions;
						let group: any = {};

						this.questions.map(question => { return this.setQuestionMask(question); });

						this.questions.forEach((question) => {
							group[question.code] = new FormControl('', Validators.required);
						});

						this.formSecurityQuestions = new FormGroup(group);

						return this.questions;

					});
				} else {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'CPF não encontrado' });
					this.preload(false);
				}

			});

		}
	}

	sendAnswers() {
		let answerError: boolean = false;


		this.questions.forEach((question, index) => {
			this.preload(true);
			this.customerServiceService.sendAnswer(this.formVerifyCpf.value.cpf, question, this.formSecurityQuestions.value[question.code]).subscribe((data: any) => {
				question.error = false;
			}, error => {
				answerError = true;
				question.error = true;
				this.preload(false);
			});
		});

		setTimeout(() => {
			if (!answerError) {
				this.getAccessionsClient()
			}
		}, 10000)

	}

	setQuestionMask(question) {
		question.mask = [];

		if (question.type === 1) {
			for (let i = 0; i < question.size; i++) {
				question.mask.push(/./);
			}
		} else if (question.type === 2) {
			for (let i = 0; i < question.integers; i++) {
				question.mask.push(/\d/);
			}
		} else if (question.type === 3) {
			question.mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
		}

		return question;

	}

	getAccessionsClient() {
		this.customerServiceService.getAccessionsByCpf(this.formVerifyCpf.value.cpf).subscribe((accounts: any) => {
			this.customerServiceService.setAccount(accounts[0]).subscribe((retorno: any) => {
				if (retorno.Sucesso) {
					this.preload(false);
					AppEventDispatcher.dispatch(EventTypes.CUSTUMER_SERVICE_INFO, {show: true});
					this.router.navigate(['']);
				}
			}, error => {
				this.preload(false);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			});
		}, error => {
			this.preload(false);
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="search-client"]', show: active, delay: delay });
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/customer-service/search-client/search-client.component.ts